import React, { CSSProperties } from 'react';
import ReactDOM from 'react-dom';
import { Popper, Arrow } from 'react-popper';
import Transition from 'react-transition-group/Transition';
import classnames from 'classnames';
import badgeDescriptionBackground from 'ck-core-client/graphics/badges/badge-description-background.svg';

import './index.less';

export enum TooltipTheme {
	White = 'white',
	Purple = 'purple',
	BlueMaze = 'blueMaze'
}

const ThemeBackgroundImages: { [theme in TooltipTheme]?: string } = {
	blueMaze: badgeDescriptionBackground
};

export enum TooltipPlacement {
	Top = 'top',
	Left = 'left',
	Right = 'right',
	Bottom = 'bottom'
}

export interface TooltipProps {
	isOpen: boolean;
	placement?: TooltipPlacement;
	children: JSX.Element;
	defaultStyle?: CSSProperties;
	transitionStyles?: {
		[state: string]: CSSProperties;
	};
	theme?: TooltipTheme;
	modifiers?: ReactPopperModifiers;
}

export interface ReactPopperModifiers {
	[property: string]: any;
}

const timeout = 150;
const Tooltip = ({
	isOpen,
	placement = TooltipPlacement.Left,
	children,
	theme = TooltipTheme.White,
	defaultStyle = {
		transition: `opacity ${timeout}ms ease-in-out`,
		opacity: 0
	},
	transitionStyles = {
		entered: {
			opacity: 1
		}
	},
	modifiers
}: TooltipProps) => {
	const customBackgroundImage = ThemeBackgroundImages[theme];
	const customInlineImage = customBackgroundImage
		? { backgroundImage: `url('${customBackgroundImage}')` }
		: {};
	return (
		<Transition in={isOpen} timeout={timeout} mountOnEnter={true} unmountOnExit={true}>
			{(transitionState: string) =>
				ReactDOM.createPortal(
					<Popper
						modifiers={modifiers}
						positionFixed={true}
						placement={placement}
						className={classnames('Tooltip', 'Tooltip--theme-' + theme)}
						style={{
							...defaultStyle,
							...transitionStyles[transitionState]
						}}
					>
						<div className="Tooltip__content" style={{ ...customInlineImage }}>
							{children}
						</div>
						<Arrow className="Tooltip__arrow" />
					</Popper>,
					document.querySelector('#TooltipWrapper')
				)
			}
		</Transition>
	);
};

export default Tooltip;
